import { TariffProvider } from "./TariffContext";
import { UserInfoProvider } from "./UserInfoContext";
import { SwitchProvider } from "./SwitchContext";

const ContextProvider = ({ children }) => {
  return (
    <UserInfoProvider>
      <TariffProvider>
        <SwitchProvider>{children}</SwitchProvider>
      </TariffProvider>
    </UserInfoProvider>
  );
};

export default ContextProvider;
